/**
 * Le Club — tier matrix.
 *
 * Progressive enhancement only. Without JS the table scrolls horizontally and
 * every column stays readable; with JS, small screens get a one-tier-at-a-time
 * filter and pointer devices get a column spotlight. The legal footnotes
 * likewise show in full without JS, and fold to their first lines with it.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function initMatrix(root) {
    var table = root.querySelector('[data-leclub-matrix]');
    if (!table) return;

    var filter = root.querySelector('[data-leclub-filter]');
    var buttons = filter ? Array.prototype.slice.call(filter.querySelectorAll('.leclub-matrix__filter-btn')) : [];
    var mq = window.matchMedia(MOBILE);

    function setColumn(index) {
      table.setAttribute('data-active-col', String(index));
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.dataset.col === String(index) ? 'true' : 'false');
      });
    }

    function syncViewport() {
      if (!filter) return;
      if (mq.matches) {
        filter.hidden = false;
        table.classList.add('is-filtered');
      } else {
        filter.hidden = true;
        table.classList.remove('is-filtered');
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setColumn(parseInt(btn.dataset.col, 10) || 0);
      });
    });

    // Column spotlight, pointer devices only — never hijacks touch scrolling.
    if (window.matchMedia('(hover: hover)').matches) {
      table.addEventListener('mouseover', function (event) {
        var cell = event.target.closest('[data-col]');
        if (cell && table.contains(cell)) {
          table.setAttribute('data-hover-col', cell.dataset.col);
        }
      });
      table.addEventListener('mouseleave', function () {
        table.removeAttribute('data-hover-col');
      });
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', syncViewport);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(syncViewport);
    }

    syncViewport();
  }

  // Legal footnotes: the first row of notes, each cut to the lines set in
  // the editor, and a toggle for the rest. Folded only when there is more.
  function initNotes(root) {
    var list = root.querySelector('[data-leclub-notes]');
    var toggle = root.querySelector('[data-leclub-notes-toggle]');
    var label = toggle && toggle.querySelector('[data-leclub-notes-label]');
    if (!list || !toggle || !label) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('.leclub-notes__item'));
    if (!items.length) return;
    var open = false;

    // Measured unfolded: which notes run past the line limit, and which sit
    // below the first row (on phones, every note after the first).
    function measure() {
      if (open) return;
      list.classList.remove('is-folded');
      items.forEach(function (item) { item.classList.remove('is-tucked'); });

      var style = getComputedStyle(list);
      var limit = (parseFloat(style.getPropertyValue('--notes-lines')) || 2) * parseFloat(style.lineHeight);
      var firstRow = items[0].offsetTop;
      var more = false;

      items.forEach(function (item) {
        var text = item.querySelector('.leclub-notes__text');
        if (item.offsetTop > firstRow + 1) {
          item.classList.add('is-tucked');
          more = true;
        } else if (text && text.offsetHeight > limit + 1) {
          more = true;
        }
      });

      list.classList.toggle('is-folded', more);
      toggle.hidden = !more;
    }

    toggle.addEventListener('click', function () {
      open = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = open ? toggle.dataset.less : toggle.dataset.more;
      if (open) {
        list.classList.remove('is-folded');
        return;
      }
      measure();
      // Folding back can leave the visitor below the notes; bring them back.
      if (list.getBoundingClientRect().top < 0) {
        list.scrollIntoView({ block: 'start' });
      }
    });

    var frame;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(measure);
    });

    // Line height depends on the web font; measure again once it has loaded.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }

    measure();
  }

  function initSection(root) {
    initMatrix(root);
    initNotes(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.leclub-tiers').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor support.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
